import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Calendar, Carousel, Icon, Col, Row, Card, Spin, message, Button, Modal, Select, Radio } from 'antd'
import { Queries } from '../../../graphql'
import Container from '../../../components/user/Container'
import { monthDataSet } from '../../../config/datasets'
import { checkMonth } from '../../../utils/checkMonthArrow'
import moment from 'moment'
import iconsFirst from '../../../assets/images/icons/time-first.png'
import iconsLast from '../../../assets/images/icons/time-last.png'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
//////////////////////addmodalINTERNAL_SERVER_ERROR

const { TabPane } = Tabs
const { Text, Title } = Typography

const dateFormat = '';

const radioStyle = {
    display: 'block',
  };

class Attendace extends Component {

    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.carousel = React.createRef();
    }

    state = {
        detailTimeAttendance: [],
        date: moment(),
        monthOnchang: moment().month(),
        monthOld: moment().month(),
        // monthOnchang:0,
        year: moment().year(),
        yearOnCange:moment().year(),
        onSelect: moment(),
        loadingDataTimeAttendance: false,
        checkOnClickCarousel: true,
        nextArrow: true,
        prevArrow: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        disabledCalenda: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        selectOrganization:[],
		profileKey:null,
		organizationName: null
    }

    next = async () => {
        const { monthOnchang } = this.state
        this.carousel.next()
        await this.setState({
            checkOnClickCarousel: true
        })
        // this.onChangeMonth()
    }

    previous = async () => {
        this.carousel.prev()
        await this.setState({
            checkOnClickCarousel: true
        })
        // this.onChangeMonth()
    }

    showDetailtimeAttendance = () => {
        const { detailTimeAttendance } = this.state
        const lengthDetail = (detailTimeAttendance.times.length) - 1;
        return detailTimeAttendance.times.map((value, keys) => {
            if (keys > 0 && keys !== lengthDetail) {
                return <>
                    {
                        keys == 1 &&
                        <Col className="mb-2 mt-3">
                            <Text className="color-gray">
                                History Time Stamp
                            </Text>
                        </Col>
                    }
                    <Col className="mt-1">
                        <Row>
                            <Card style={{ borderRadius: "10px" }} className="custom-card custom-card-black">
                                <Col span={24}>
                                    <Row>
                                        <Col span={18} className="pt-1">
                                            <Text className="color-white">
                                                Time Stamp #{keys + 1}
                                            </Text>
                                        </Col>
                                        <Col span={6}>
                                            <Title level={3} className="color-gray-soft-blue my-0">
                                                {moment(detailTimeAttendance.times[keys].timestamp).format("HH:mm")}
                                            </Title>
                                        </Col>
                                    </Row>
                                </Col>
                            </Card>
                        </Row>
                    </Col>
                </>
            } else if (keys == lengthDetail) {
                if(lengthDetail !== 0){
                    return <>
                        <Col className="mb-2 mt-3">
                            <Text className="color-gray">
                                Last Out
                            </Text>
                        </Col>
                        <Col>
                            <Row>
                                <Card style={{ borderRadius: "10px" }} className="custom-card">
                                    <Col xs={4}>
                                        <img src={iconsFirst} style={{ maxWidth: '100%', height: 'auto' }} />
                                    </Col>
                                    <Col xs={19} offset={1}>
                                        <Text>
                                            Time Stamp #{keys + 1}
                                        </Text>
                                        <Title level={3} className="color-orange my-0">
                                            {moment(detailTimeAttendance.times[keys].timestamp).format("HH:mm")}
                                        </Title>
                                    </Col>
                                </Card>
                            </Row>
                        </Col>
                    </>
                }
            }
        })
    }

    fetchTimeAttendanceByDate = async () => {
        const { client } = this.props
        const { profileKey } = this.state
        this.setState({
            loadingDataTimeAttendance:false,
            disabledCalenda:true
        })

        console.log(profileKey)
        try {
            const { date } = this.state
            const { data, errors } = await client.query({
                query: Queries.fetchTimeAttendanceByDate,
                variables: {
                    date: moment(date).format("YYYY-MM-DD"),
                    sorting: 'ASC',
                    profileKey
                },
            })

            //////////////////////addmodalINTERNAL_SERVER_ERROR
            if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
                await this.setState({
                    showModalErrors: true
                })
            }else{
                 await this.setState({
                    detailTimeAttendance: data.timeAttendanceByDate,
                    loadingDataTimeAttendance: true
                },() => {
                    this.setState({
                        disabledCalenda:true
                    })
                })
            }

           
        } catch (error) {
            this.setState({
                disabledCalenda:false
            })
            // console.log('error',error)
            // const errorMessage = error.graphQLErrors[0].message
            // message.error("Token is expired.")
        }
    }

    onChangeCalendar = async (value, mode) => {
        const { monthOnchang, date } = this.state
        await this.setState({
            date: moment(value),
            monthOnchang: moment(value).month(),
            loadingDataTimeAttendance: false,
            checkOnClickCarousel: false
        })
        await this.carousel.goTo(moment(value).month(), 'false');
        await this.fetchTimeAttendanceByDate()
    };

    onChangeMonth = async (e, keys) => {
        this.setState({
            prevArrow: true,
            nextArrow: true
        })

        const { date, year, monthOnchang, monthOld, yearOnCange } = this.state
        const monthDefual = moment().month()
        let yearCheck = yearOnCange;
       
        const checkMonthValue = checkMonth(e, monthOld, year, yearOnCange);
        if (checkMonthValue) {
            if (checkMonthValue[0] == 'arrowForm1') {
                await this.setState({
                    prevArrow: true,
                    nextArrow: false,
                })
            } else if (checkMonthValue[0] == 'arrowForm2') {
                await this.setState({
                    prevArrow: false,
                    nextArrow: true,
                })
            } else if (checkMonthValue[0] == 'arrowFormFalse') {
                await this.setState({
                    prevArrow: false,
                    nextArrow: false,
                })
            }

            if(e+''+checkMonthValue[1] == moment().month()+''+moment().year()-1){
                await this.setState({
                    prevArrow: true,
                    nextArrow: false,
                })
            }

            if (checkMonthValue[1]) {
                await this.setState({
                    year: checkMonthValue[1],
                })
            }
        }
        var day = moment(date).date();
        var yearSelect = checkMonthValue[1];
        var month = e; //octobe        // console.log('e',e)
        var checkMonthDay = moment([yearSelect, month, day]);
        if(checkMonthDay._d == 'Invalid Date'){
            var newDate = moment(yearSelect+'-'+(month+1)).clone().endOf('month').date()
            checkMonthDay = moment([yearSelect, month, newDate]);
        }

        if (e !== null && keys) {
            await this.setState({
                date: checkMonthDay,
                loadingDataTimeAttendance: false,
                checkOnClickCarousel: true,
                year:yearSelect,
                yearOnCange:checkMonthValue[2],
                monthOld: month
            })

            await this.fetchTimeAttendanceByDate()
        }
    }

    customDatePush = (current) => {
        let date = moment().format('DD');
        let customDate = moment().add(-1, 'year').add(-1, 'month');
        let customDatePush = moment().add(0, 'year');
        return current && current <= moment(customDate, "year") || current >= moment(customDatePush, "year");
    }

    fetchProfile = async () => {
		const { selectOrganization } = this.state
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})

			if(data.fetchProfile){
				selectOrganization.filter(selectOrganization => selectOrganization.profileKey == data.fetchProfile.currentProfile).map(filterData => (
					this.setState({
						organizationName: filterData.workProfile.orgPosition.positionName+' '+filterData.workProfile.orgUnit.orgUnitName+' '+filterData.workProfile.organization.orgName
					})
				))

				this.setState({
					profileKey: data.fetchProfile.currentProfile
				})
				// return data.fetchProfile
			}
			
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}

    changeProfileKey = async (e) =>{
		const { selectOrganization } = this.state
		await selectOrganization.filter(selectOrganization => selectOrganization.profileKey == e.target.value).map(filterData => (
			this.setState({
				organizationName: filterData.workProfile.orgPosition.positionName+' '+filterData.workProfile.orgUnit.orgUnitName+' '+filterData.workProfile.organization.orgName,
				profileKey: e.target.value
			},()=>{
                this.fetchTimeAttendanceByDate()
            })
		))

	}

    accordingProfile = async () => {
		const { client } = this.props
		const { profile } = this.state
		try {
			const { data, errors } = await client.query({
				query: Queries.accordingProfile,
			})
			if (data.accordingProfile.length > 1) {
				this.setState({
					organizationShow: true,
					selectOrganization: data.accordingProfile
				})
			}
		} catch (error) {
			console.log('error', error)
		}
	}

    async componentDidMount() {
        const { monthOnchang, date, detailTimeAttendance } = this.state
        this.carousel.goTo(monthOnchang);
		await this.fetchProfile()
        await this.fetchTimeAttendanceByDate()
        await this.accordingProfile()
    }

    render() {
        const { history, location, match, staticContext } = this.props
        const { 
            loadingDataTimeAttendance, 
            date, 
            detailTimeAttendance,
            checkOnClickCarousel, 
            nextArrow, 
            prevArrow, 
            year, 
            disabled,
            profileKey,
			selectOrganization,
			organizationName
        } = this.state
        const props = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div className="card-container" id="page-time-attendance">
                    <Row>
                        <Col xs={24} sm={24} md={24} className="mb-4">
                            <div style={{ width: "100%" }} className="">
                                {
                                    (profileKey && selectOrganization.length !== 0 ) &&
                                    <>
                                        <label>กรุณาเลือกหน่วยงานที่ท่านปฏิบัติงาน</label>
                                        {/* <Select defaultValue={profileKey} style={{ width:"100%" }} onChange={this.changeProfileKey}>
                                            {
                                                selectOrganization.map(item => (
                                                    <Select.Option key={item.workProfile.organization.orgName} value={item.profileKey}>
                                                        { item.workProfile.orgPosition.positionName+' '+item.workProfile.orgUnit.orgUnitName+' '+item.workProfile.organization.orgName }
                                                    </Select.Option>
                                                ))
                                                }
                                        </Select> */}
                                        <Radio.Group  defaultValue={profileKey} style={{ width:"100%" }} onChange={this.changeProfileKey}>
                                            {
                                                selectOrganization.map(item => (
                                                    <Radio style={radioStyle} value={item.profileKey}>
                                                        { item.workProfile.orgPosition.positionName+' '+item.workProfile.orgUnit.orgUnitName+' '+item.workProfile.organization.orgName }
                                                    </Radio>
                                                ))
                                            }
                                        </Radio.Group>
                                    </>
                                }
                                
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ opacity: profileKey ? "1" : '0' }}>
                        <Col xs={24} sm={24} md={16} className="mb-4" style={{ disabled }}>
                            <div style={{ position: "relative" }}>
                                <Button
                                    className="arrow-custom-time arrow-custom-time-left"
                                    onClick={this.previous}
                                    disabled={prevArrow ? true : false}
                                >
                                    <Icon type="left" />
                                </Button>
                                <Carousel
                                    dots={false}
                                    ref={
                                        node => (
                                            this.carousel = node
                                        )
                                    }
                                    {...props}
                                    afterChange={(value) =>
                                        this.onChangeMonth(value, checkOnClickCarousel)
                                    }
                                    className="py-5"
                                >
                                    {
                                        monthDataSet.map((valueMonth, keysMonth) =>
                                            <div key={keysMonth} align="center">
                                                <Title level={1} className="color-white mb-0">
                                                    เดือน{valueMonth} { year+543 } <br></br>
                                                </Title>
                                                <span className="color-orange">เวลาเข้า - ออก</span>
                                            </div>

                                        )
                                    }
                                </Carousel>
                                <Button 
                                    className="arrow-custom-time arrow-custom-time-right" 
                                    onClick={this.next} 
                                    disabled={nextArrow ? true : false}
                                >
                                    <Icon type="right" />
                                </Button>
                            </div>
                            <Calendar
                                fullscreen={false}
                                mode="month"
                                value={date}
                                onSelect={(value) =>
                                    this.onChangeCalendar(value)
                                }
                                locale={{ 
                                 lang: { 
                                    locale: 'en', 
                                    dayFormat: moment.updateLocale('en', { 
                                       weekdaysMin: [ 'อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.' ]
                                    }) 
                                 } 
                              }} 
                                disabledDate={this.customDatePush}
                            />
                        </Col>
                        <Col xs={24} sm={24} md={7} offset={1}>
                            {
                                (loadingDataTimeAttendance && detailTimeAttendance.times.length > 0) &&
                                    <>
                                        <Col >
                                            <Row>
                                                <Col className="mb-2">
                                                    <Text className="color-gray">
                                                        First In
                                                            </Text>
                                                </Col>
                                                <Card style={{ borderRadius: "10px" }} className="custom-card">
                                                    <Col xs={4}>
                                                        <img src={iconsLast} style={{ maxWidth: '100%', height: 'auto' }} />
                                                    </Col>
                                                    <Col xs={19} offset={1}>
                                                        <Text>
                                                            {/* { detailTimeAttendance.times.length }  */}
                                                                    Time Stamp #1
                                                                </Text>
                                                        <Title level={3} className="color-orange my-0">
                                                            {moment(detailTimeAttendance.times[0].timestamp).format("HH:mm")}
                                                        </Title>
                                                    </Col>
                                                </Card>
                                            </Row>
                                        </Col>
                                        {this.showDetailtimeAttendance()}
                                    </>
                                ||
                                (loadingDataTimeAttendance && detailTimeAttendance.times.length == 0) &&
                                    <Col>
                                        <Row>
                                            <Card style={{ borderRadius: "10px" }} >
                                                <Col span={24}>
                                                    <Title level={4} className="mb-0" align="center">
                                                    ไม่พบข้อมูลของการเข้า - ออกงาน
                                                    </Title>
                                                </Col>
                                            </Card>
                                        </Row>
                                    </Col>
                                ||
                                <Col align="center" className="mt-5">
                                    <Spin size="large" />
                                </Col>
                            }
                        </Col>
                    </Row>
                </div>
            </Container>
        )
    }
}

Attendace.propTypes = {
    //
}

export default withApollo(Attendace)